import type { MarketIdentifiers } from './market';
import type { addressType } from './util';

export enum StrategyIds {
	ETH = 'aave-eth-long-polynomial-eth-short',
	OP = 'aave-op-long-polynomial-op-short',
	LINK = 'aave-link-long-polynomial-link-short',
	AAVE = 'aave-aave-long-polynomial-aave-short'
}

export class StrategyLeg {
	'margin': string;
	'size': string;
	'protocol': string;
	'data'?: {};
}

export class strategyConfigType {
	'aave_collateral_token_address': addressType;
	'asset': string;
	'asset_symbol': string;
	'asset_logo': string;
	'marketIdentifier': MarketIdentifiers;
	'longConfig': {
		platform: string;
		logo_url: string;
		type: string;
	};
	'shortConfig': {
		platform: string;
		logo_url: string;
		type: string;
	};
}
export class StrategyType extends strategyConfigType {
	'id': StrategyIds;
	'long': {
		platform: string;
		supplyPool: {
			asset: string;
			assetDecimals: number;
			assetAddress: string;
			assetPrice: string;
			supplyRatePct: string;
			borrowRatePct: string;
			currentSupplySize: string;
			maxSupplySize: string;
			currentBorrowSize: string;
			maxBorrowSize: string;
			maxLtvAsCollateralPct: string;
			liquidationThresholdPct: string;
			liquidationBonusPct: string;
		};
		borrowPool: {
			asset: string;
			assetAddress: string;
			assetDecimals: number;
			assetPrice: string;
			supplyRatePct: string;
			borrowRatePct: string;
			currentSupplySize: string;
			maxSupplySize: string;
			currentBorrowSize: string;
			maxBorrowSize: string;
			maxLtvAsCollateralPct: string;
			liquidationThresholdPct: string;
			liquidationBonusPct: string;
		};
		flashloanPremiumPct: string;
		maxLeveragePossible: string;
	};
	'short': {
		platform: string;
		marketAddress: string;
		assetName: string;
		marketIdentifier: MarketIdentifiers;
		openInterest: string;
		currentOraclePrice: string;
		marketSize: string;
		fundingRatePercentageLast1h: string;
		maxMarketValue: string;
		shortOI: string;
		longOI: string;
		skewScale: string;
		makerFee: string;
		takerFee: string;
		fundingVelocity: string;
	};
}
export class AavePostTradeDetails {
	'platform': 'AAVE';
	'postTradeDetails': {
		flashLoanFeeUSD: string;
		swapFeeUSD: string;
		supplySizeUSD: string;
		supplySizeNative: string;
		debtSizeUSD: string;
		liquidationPriceUSD: string;
		fillPriceUSD: string;
		flashLoanAmountUSD: string;
	};
}

export class PolynomialPostTradeDetails {
	'platform': 'POLYNOMIAL';
	'fee': string;
	'liquidationPrice': string;
	'totalMargin': string;
	'accessibleMargin': string;
	'status': number;
	'fillPrice': string;
}

export class StartergyPostTradeDetails {
	'long': AavePostTradeDetails;
	'short': PolynomialPostTradeDetails;
}

export class StrategyPosition extends strategyConfigType {
	'strategyIdentifier': StrategyIds;
	'long': AaveLongPosition;
	'short': PolynomialShortPosition;
}

export class FeeInfo {
	'totalCost': string;
	'AaveFlashLoanFee': string;
	'AaveSwapFee': string;
	'PolynomialFee': string;
}

export class AaveLongPosition {
	'platform': 'AAVE';
	'fillPrice': string;
	'originalSupplySizeUnderlying': string;
	'originalSupplySizeUsd': string;
	'currentSupplySizeUnderlying': string;
	'currentSupplySizeUsd': string;
	'originalDebtSizeUnderlying': string;
	'originalDebtSizeUsd': string;
	'currentDebtSizeUnderlying': string;
	'currentDebtSizeUsd': string;
	'healthFactor': string;
	'liquidationThreshold': string;
	'currentLtv': string;
	'liquidationPrice': string;
}

export class PolynomialShortPosition {
	'platform': 'POLYNOMIAL';
	'asset': string;
	'marketIdentifier': MarketIdentifiers;
	'marketAddress': string;
	'avgEntryPrice': string;
	'liquidationPrice': string;
	'feesPaid': string;
	'margin': string;
	'pnl': string;
	'totalFeesPaid': string;
	'size': string;
	'accruedFunding': string;
}
